export const cardTypes = {
    1: "credit",
    2: "debit",
    3: "debit_elo_caixa",
    "credit": 1,
    "debit": 2,
    "debit_elo_caixa": 2,
}
